import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Input from "@material-ui/core/Input";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import CheckBox from "../../../../../../Component/Forms/Checkbox";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    maxWidth: 300,
  },
  options: {
    width: "auto",
    overflow: "hidden",
    position: "relative",
    paddingTop: "6px",
    paddingBottom: "6px",
    whiteSpace: "nowrap",
    display: "flex",
    textAlign: "left",
    alignItems: "center",
    justifyContent: "flex-start",
    verticalAlign: "middle",
    marginBottom: "2px",
  },
  optionsHeading: {
    display: "flex",
    flexDirection: "column",
    verticalAlign: "middle",
    justifyContent: "center",
    textAlign: "center",
    fontSize: "1.05rem",
    marginBottom: "2px",
  },
  paragraph: {
    margin: 0,
    fontSize: "0.9rem",
    color: "grey",
  },
  cursor: {
    cursor: "pointer",
    "&:hover": {
      background: "rgb(232,232,232)",
    },
  },
  selected: {
    background: "linear-gradient(#d6d6d6, #d6d6d6)",
    backgroundColor: "#d6d6d6" /* for IE */,
    color: "#000000",
  },
  notSelected: {
    backgroundColor: "white",
  },
  leftPadding: {
    paddingLeft: "6px",
  },
}));

const MenuProps = {
  PaperProps: {
    style: {
      width: 250,
    },
  },
};

const copyObject = (param) => {
  return JSON.parse(JSON.stringify(param));
};

const joinSelectedElements = (selected) =>
  (selected.join(", ") || "").toUpperCase();

const AllConditions = ({
  conditions,
  updatePermissions,
  recordTypeName,
  actionName,
}) => {
  const classes = useStyles();
  const [allConditions, setAllConditions] = useState({});
  const [tickedCondtions, setTickedConditions] = useState([]);

  const { t } = useTranslation();

  useEffect(() => {
    setAllConditions(conditions);
    let existingTickedConditions = [];
    for (let cond in conditions) {
      if (conditions[cond].isSelected === true) {
        existingTickedConditions.push(cond);
      }
    }
    setTickedConditions(existingTickedConditions);
  }, [conditions]);

  const handleChange = (event) => {
    let chunks = [];
    if (
      event.target.value &&
      event.target.value.length > 1 &&
      event.target.value[event.target.length - 1] === "boolean-value"
    ) {
      return;
    }
    //event triggered from hr tag
    if (event.target.value[event.target.value.length - 1] === undefined) return;

    if (event.target.value && event.target.value.length === 1) {
      chunks = event.target.value[0].split("--");
    } else if (event.target.value && event.target.value.length > 1) {
      chunks = event.target.value[event.target.value.length - 1].split("--");
    }
    if (chunks[0] === "Select" && chunks[1] === "All") {
      let groupName = chunks[chunks.length - 2];
      let alreadyTickedConditions = [...tickedCondtions];
      const newState = copyObject(allConditions);
      if (alreadyTickedConditions.indexOf(groupName) >= 0) {
        alreadyTickedConditions.splice(
          alreadyTickedConditions.indexOf(groupName),
          1
        );
        //REMOVE ALL POSSIBLE VALUES OF THIS CONDITION
        newState[groupName].isSelected = false;
        newState[groupName].possibleValues.forEach((item) => {
          item.isTicked = false;
        });
      } else {
        alreadyTickedConditions = [...alreadyTickedConditions, groupName];
        newState[groupName].isSelected = true;
        //ADD ALL POSSIBLE VALUES OF THIS CONDITION
        newState[groupName].possibleValues.forEach((item) => {
          item.isTicked = true;
        });
      }

      setAllConditions(newState);
      setTickedConditions(alreadyTickedConditions);
    } else {
      let chunks;
      if (event.target.value && event.target.value.length === 1) {
        chunks = event.target.value[0].split("-");
      } else if (event.target.value && event.target.value.length > 1) {
        chunks = event.target.value[event.target.value.length - 1].split("-");
      }

      if (chunks[0] === "single") {
        const conditionName = chunks[1];
        const index = parseInt(chunks[2]);
        const newState = copyObject(allConditions);

        if (
          newState[conditionName]["schema"] &&
          newState[conditionName]["schema"] === "boolean"
        ) {
          newState[conditionName].possibleValues[index].isTicked =
            !newState[conditionName].possibleValues[index].isTicked;
          if (index === 0) {
            //Single value boolean logic
            if (
              Array.isArray(newState[conditionName].possibleValues) &&
              newState[conditionName].possibleValues.length > 1
            )
              newState[conditionName].possibleValues[1].isTicked = false;
          } else if (index === 1) {
            newState[conditionName].possibleValues[0].isTicked = false;
          }
        } else {
          //Multiple value select/unselect logic
          newState[conditionName].possibleValues[index].isTicked =
            !newState[conditionName].possibleValues[index].isTicked;
        }
        let alreadyTickedConditions = [...tickedCondtions];
        let flag = false;
        //check if any option is ticked under a condition
        for (let valueObject of newState[conditionName].possibleValues) {
          if (valueObject.isTicked) {
            flag = true;
            break;
          }
        }

        if (flag) {
          newState[conditionName].isSelected = true;
          if (alreadyTickedConditions.indexOf(conditionName) < 0) {
            alreadyTickedConditions = [
              ...alreadyTickedConditions,
              conditionName,
            ];
          }
        }
        if (!flag) {
          newState[conditionName].isSelected = false;
          if (alreadyTickedConditions.indexOf(conditionName) >= 0) {
            alreadyTickedConditions.splice(
              alreadyTickedConditions.indexOf(conditionName),
              1
            );
          }
        }
        setAllConditions(newState);
        setTickedConditions(alreadyTickedConditions);
      }
    }
  };

  const handleClose = () => {
    updatePermissions(recordTypeName, actionName, allConditions);
  };

  return (
    <div>
      <FormControl className={classes.formControl} fullWidth>
        <Select
          labelId="mutiple-checkbox-label-add"
          id="mutiple-checkbox-add"
          multiple
          value={tickedCondtions}
          onChange={handleChange}
          input={<Input placeholder="none" />}
          renderValue={joinSelectedElements}
          MenuProps={MenuProps}
          onClose={handleClose}
        >
          {allConditions &&
            Object.keys(allConditions).map((cond) => {
              let list = [];
              if (
                allConditions[cond].schema &&
                allConditions[cond].schema === "boolean"
              ) {
                list = allConditions[cond].possibleValues.map(
                  (condition, index) => {
                    if (typeof condition === "object") {
                      return (
                        <div
                          className={`${classes.options} ${classes.cursor}`}
                          key={`boolean-${index}`}
                          value={`single-${cond}-${index}-${condition.label}`}
                        >
                          <CheckBox
                            checked={
                              allConditions[cond].possibleValues[index].isTicked
                            }
                          />
                          {condition.label}
                        </div>
                      );
                    }
                  }
                );
                list.push(<hr />);
                list.unshift(
                  <div
                    className={classes.optionsHeading}
                    value="boolean-value"
                    key={`boolean-${actionName}`}
                  >
                    {t(`labels.accessControl.rule.conditionLabels.${cond}`)}
                  </div>
                );
              } else {
                list = allConditions[cond].possibleValues.map(
                  (condition, index) => {
                    if (typeof condition === "object") {
                      return (
                        <div
                          className={`${classes.options} ${
                            classes.leftPadding
                          } ${classes.cursor} ${
                            allConditions[cond]["possibleValues"][index]
                              .isTicked
                              ? classes.selected
                              : classes.notSelected
                          }`}
                          key={`multiple-${index}`}
                          value={`single-${cond}-${index}-${condition.value}`}
                        >
                          {condition.label === "AML" ||
                          condition.label === "KYC"
                            ? t(
                                `labels.record.sections.${condition.label.toLowerCase()}`
                              )
                            : condition.label}
                        </div>
                      );
                    }
                  }
                );
                list.push(<hr />);
                list.unshift(
                  <div
                    className={`${classes.optionsHeading} ${classes.cursor}`}
                    key={`${cond}-heading`}
                    value={`Select--All--${cond}--recordType`}
                  >
                    {t(`labels.accessControl.rule.conditionLabels.${cond}`)}
                    <p className={classes.paragraph}>
                      {t("labels.common.selectAll")}
                    </p>
                  </div>
                );
              }

              return list;
            })}
        </Select>
      </FormControl>
    </div>
  );
};

export default React.memo(AllConditions);
